import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { fetchCardsData } from "services/apis";
import { formatCount } from "utils/formatData";
import { useNavigate } from "react-router-dom";

function TopCards() {
  const [data, setData] = useState({});
  const navigate = useNavigate();
  useEffect(() => {
    const getData = async () => {
      try {
        const res = await fetchCardsData();
        if (res?.success) setData(res.data || {});
      } catch (err) {
        console.error("Error fetching card data:", err);
      }
    };
    getData();
  }, []);

  const getValue = (key) => data?.[key]?.[0]?.userCount ?? 0;
  const total = getValue("totalUser");
  const subscribed = getValue("subscribedUser");
  const joinedLast = getValue("joinedLast");
  const joinedMonths = data?.joinedLast?.[0]?.month ?? 0;
  const reported =  data?.reportedUserCount?.reportedUserCount ?? 0 
 
  const getCardProps = (type) => {
    switch (type) {
      case "total":
        return {
          title: "Total Users",
          icon: "groups",
          color: "dark",
          value: total,
          percentage: {
            color: total > 0 ? "success" : "error",
            label: "Total users present on Weddz",
          },
        };
      case "subscribed":
        return {
          title: "Subscribed Users",
          icon: "paid",
          color: "info",
          value: subscribed,
          percentage: {
            color: subscribed > 0 ? "success" : "error",
            label:"Total subscriptions till now",
          },
        };
      case "joined":
        return {
          title: "Recently Joined",
          icon: "person_add",
          color: "success",
          value: joinedLast,
          percentage: {
            color: joinedLast > 0 ? "success" : "error",
            label: `Users joined over the past ${joinedMonths} month${joinedMonths === 1 ? "" : "s"}`,
          },
        };
      case "reported":
        return {
          title: "Reported Users",
          icon: "report_problem",
          color: "primary",
          value: reported,
          percentage: {
            color: reported > 0 ? "error" : "success",
            label: reported > 0 ? "Needs attention" : "No recent reports",
          },
        };
      default:
        return {};
    }
  };

  const renderCard = (type) => {
    const { title, icon, color, value, percentage } = getCardProps(type);
    return (
      <Grid item xs={12} md={6} lg={3} key={type}>
        <MDBox mb={1.5} onClick={() => navigate(`/users`)} sx={{ cursor: "pointer" }}>
          <ComplexStatisticsCard
            title={title}
            icon={icon}
            color={color}
            count={formatCount(value)}
            percentage={percentage}
          />
        </MDBox>
      </Grid>
    );
  };

  return (
    <Grid container spacing={3}>
      {["total", "subscribed", "joined", "reported"].map(renderCard)}
    </Grid>
  );
}

export default TopCards;
